module.exports = __webpack_public_path__ + "media/src/web/images/home/address_bg-d1ce666ad40a2444c49388a983492c85.png";